import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://smxwiftwgzzkzacsyedo.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNteHdpZnR3Z3p6a3phY3N5ZWRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUyOTc0NzQsImV4cCI6MjA2MDg3MzQ3NH0.2XU5Mki4uvQBuQFkeyvkYzvvZWiYaU8hkmd3FVVEC1g';

export const supabase = createClient(supabaseUrl, supabaseKey);